import { handleDeleteRequest, handleGetRequest, handlePutRequest } from ".";
import { getProfileImage } from "../../Common";
import { URI } from "../../constants/URI";
import { setUser } from "../slices/userSlice";
import { store } from "../store";

export const getUserProfile = async () => {
  const res = await handleGetRequest(URI.user);
  console.log("🚀 ~ getUserProfile ~ res:", res);

  if (res) store.dispatch(setUser(res.response));
};

export const updateUserProfile = async (data) => {
  let result = await handlePutRequest(URI.update_profile, data);
  console.log("🚀 ~ updateUserProfile ~ result:", result);
  getProfileImage();
  await getUserProfile();
};

export const deleteUser = async () => {
  await handleDeleteRequest(URI.delete_user);
};
